interface HeroProps {
  query: string;
  setQuery: (value: string) => void;
  onPickCategory: (category: string) => void;
}

const hotWords = ['热血冒险', '恋爱甜宠', '科幻机甲', '悬疑推理', '治愈生活'];

export default function Hero({ query, setQuery, onPickCategory }: HeroProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    document.getElementById('latest')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative flex min-h-[520px] w-full items-center justify-center overflow-hidden md:min-h-[600px]"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20artistic%20anime%20illustration%20of%20a%20battle%20scene%20with%20silhouetted%20young%20heroes%20and%20swirling%20energy%2C%20floating%20comic%20panels%20and%20speed%20lines%2C%20vibrant%20vermillion%20red%20warm%20orange%20and%20deep%20crimson%20palette%2C%20dynamic%20manga%20composition%2C%20cinematic%20dramatic%20lighting%2C%20textured%20illustration%20style%20with%20high%20contrast%20shadows&width=1600&height=900&seq=hero-banner-manga&orientation=landscape"
          alt="嘿休漫画网址 漫画聚合站首屏背景"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/70" />

      <div className="relative z-10 w-full px-4 py-24 md:px-6 md:py-28">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="rounded-full bg-accent-500/90 px-4 py-1.5 text-xs font-semibold tracking-wide text-background-50 md:text-sm">
            <i className="ri-fire-fill mr-1" />
            漫画大全 · 人气排行 · 热门推荐
          </span>
          <h1 className="font-display mt-6 text-3xl font-bold leading-snug text-background-50 md:text-5xl md:leading-tight">
            嘿休漫画<span className="text-accent-400">网址</span>
            <span className="mt-1 block text-2xl text-background-100 md:text-3xl">
              聚合全站漫画资源，找漫画更省时
            </span>
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
            按分类、人气排行、热门推荐整理好的作品库，持续扩充。想看什么直接翻，
            从热血到治愈，从悬疑到甜宠，一网打尽。
          </p>

          <form
            onSubmit={handleSubmit}
            className="mt-8 flex w-full max-w-xl items-center gap-2 rounded-full bg-background-50/95 p-2 shadow-sm"
            role="search"
            aria-label="站内搜索"
          >
            <i className="ri-search-line pl-3 text-lg text-foreground-500" />
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="输入漫画名称或关键词，例如：热血、甜宠、悬疑…"
              className="w-full bg-transparent py-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              aria-label="搜索漫画"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-background-300">大家都在搜：</span>
            {hotWords.map((word) => (
              <button
                key={word}
                type="button"
                onClick={() => onPickCategory(word)}
                className="rounded-full border border-background-50/40 bg-foreground-950/30 px-3 py-1 text-xs text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
              >
                {word}
              </button>
            ))}
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-50/20 pt-6 text-center md:gap-8">
            <div>
              <dt className="font-display text-2xl font-bold text-accent-400 md:text-3xl">16+</dt>
              <dd className="mt-1 text-xs text-background-300">精选分类</dd>
            </div>
            <div>
              <dt className="font-display text-2xl font-bold text-accent-400 md:text-3xl">800+</dt>
              <dd className="mt-1 text-xs text-background-300">收录作品</dd>
            </div>
            <div>
              <dt className="font-display text-2xl font-bold text-accent-400 md:text-3xl">每日</dt>
              <dd className="mt-1 text-xs text-background-300">持续更新</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}